import React from 'react';
import { Card, Block, StarRating } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import Classes from '../ProfileSidebar.scss';
import average from '../../../utils/average';
import { CarDealerReviews } from '../../../../../../types/SellerProfile';

const CarDealerReviewsBlock = ({
  carDealerReviews,
  onClickReviewsControl,
}: {
  carDealerReviews: CarDealerReviews;
  onClickReviewsControl: () => void;
}) => {
  const i18n = useI18nContext();

  const { numberOfReviews, avgOverallScore, lastReviews = [] } = carDealerReviews;

  const averageScore = average(avgOverallScore);
  const showStarRating = Boolean(numberOfReviews ?? averageScore);
  const lastReview = lastReviews[0];
  const showBlock = showStarRating || lastReview;
  const reviewsLabel = i18n.t('sellerProfile.review', { count: numberOfReviews });

  if (!showBlock) {
    return null;
  }

  return (
    <Card kind="rounded" className={Classes.wrap}>
      {showStarRating && (
        <Block onClick={onClickReviewsControl} className={Classes.ratingWrap}>
          <StarRating label={`(${numberOfReviews}) ${reviewsLabel}`} rating={averageScore} />
        </Block>
      )}
      {lastReview && (
        <Block className={Classes.review}>
          <>
            <p>{lastReview.text}</p>
            <p className={Classes.textRight}>- {lastReview.name}</p>
          </>
        </Block>
      )}
    </Card>
  );
};

export default CarDealerReviewsBlock;
